module.exports = __webpack_public_path__ + "static/mabry-reg-pro-68dce4a6a5cb9d5887736ecd02b5b030.ttf";